var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-waba-analysis" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon message-icon" },
              [_c("md-icon", [_vm._v("message")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.messageTraffic")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("auto.messageTrafficReportSubtitle"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("MessageTraffic", {
                attrs: {
                  title: _vm.$t("report.messageTraffic"),
                  filters: _vm.filters,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon wallet-icon" },
              [_c("md-icon", [_vm._v("account_balance_wallet")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.walletStatus")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.walletStatusDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("WalletStatus", {
                attrs: { title: "Wallet Status", filters: _vm.filters },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }